import React from 'react';
import styled from 'styled-components';

const SalesRepView = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    position: absolute;
    width: 100%;
`;

export const PresenterView = ({ children }) => {
    return (
        <SalesRepView>
            {children}
        </SalesRepView>
    );
};

export default PresenterView;
